<div odxLayout="flex gap-small" class="flex-column h-100">
  <odx-area-header>
    <h5 class="odx-title-5" i18n="@@imageUpload.imageOverview.header">Fotos</h5>
    <odx-area-header-content>
      @if ((isReadOnlyUser$ | async) === false) {
        <odx-action-group class="mobile-photo-actions">
          <button [disabled]="(hasWritePermission$ | async) === false" odxButton (click)="openCamera()">
            <odx-icon name="picture" size="medium" alignleft></odx-icon>
            <span i18n="@@imageUpload.button.openCamera">Foto aufnehmen</span>
          </button>
          <button
            odxButton
            variant="primary"
            (click)="fileUpload.click()"
            data-testid="btn.uploadImage"
            [disabled]="(hasWritePermission$ | async) === false"
          >
            <odx-icon name="upload" size="medium" alignleft></odx-icon>
            <span i18n="@@imageUpload.button.uploadImage">Foto hochladen</span>
          </button>
        </odx-action-group>
      }
      <input
        type="file"
        (change)="onImageSelected($event)"
        accept="image/png, image/jpg, image/jpeg, image/gif, image/svg, image/svg+xml, image/webp, image/heic, image/heif, .heic, .heif"
        class="hidden"
        [attr.multiple]="businessScope === BusinessScope.FGDS ? true : null"
        #fileUpload
        data-testid="input.imageName"
      />
    </odx-area-header-content>
  </odx-area-header>
  <ng-content></ng-content>
</div>
